import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../assets/css/StudentShortDetails.css';
import exporticon from '../../assets/icons/export-data.svg';
import { useNavigate, useParams } from 'react-router-dom';
import AdvanceTable from '../../Utils/AdvanceTables';
import SearchingBar from '../../Utils/Searching';
import { getData, getDataById } from '../../API/GlobalApi';
import Notifier from '../../Utils/notify';
import { useTableFade } from '../../Utils/tableFadeHooks';
import TableLoaderOverlay from '../../Utils/tableFadingLoader';
import TableSkeleton from '../../Utils/TableSkeleton';

import { StudentLedgerDetails } from '../../Component/Modals/StudentLegerDetails';
import { copyToClipboard } from '../../Utils/copyToClipboard';
import { formatDateDDMMYYYYHHMMSS_UTC } from '../../Utils/data&dateTime';
import SingleLibraryDueDetails from './NocLibraryShortDetails';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import Select from "react-select";
import { UploadContestData } from '../../Component/Modals/UploadContestDatas';
import { UploadLibraryNocsData } from '../../Component/Modals/UploadLibraryNocData';
export default function LibraryDuesList() {



    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
    const [selectedStudent, setselectedStudent] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filterLoading, setFilterLoading] = useState(false);
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [openStudentLedgerReportModal, setStudentLedgerReportModal] = useState(false)
    const navigate = useNavigate()

    const [libraryListData, setLibraryListData] = useState([])
    const [nocStats, setNocStats] = useState("");
    const [loading, setLoading] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterQueryString, setFilterQueryString] = useState({});
    const [filterStudent, setfilterStudent] = useState([])
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [selectedFeeDetails, setselectedFeeDetails] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [openDataUpload, setOpenDataUpload] = useState(false)
    // At the top of your component
    const [backgroundLoading, setBackgroundLoading] = useState(false);
    const isFirstLoadRef = useRef(true);
    const [refreshKey, setRefreshKey] = useState(0);
    const getActivityDatas = async (
        page = 0,
        filters = filterQueryString,
    ) => {
        // ------------------------
        // 1. Stop calls during typing
        // ------------------------
        // if (!force && isSearching) return;

        // const pageNumber = page + 1;
        // const params = new URLSearchParams(query || "");
        // 
        // ------------------------
        // 2. Compute search text
        // ------------------------
        // const searchText = (searchValueRef.current || "").trim();


        // // Apply or remove search param
        // if (searchText) {
        //     params.set("search", searchText);
        // } else {
        //     params.delete("search");
        // }

        // // Sorting
        // if (order) params.set("order_by", order);

        // // Page
        // params.set("page", pageNumber);

        // const url = `academics/activities/library-noc-list/?${params.toString()}`;
        const pageNumber = page + 1;
        const queryParams = new URLSearchParams({
            ...filters,
            page: pageNumber,
        });
        queryParams.set("page", pageNumber);
        const url = `academics/activities/library-noc-list/?${queryParams.toString()}`;

        // ------------------------
        // 3. Select correct loader
        // ------------------------

        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }


        try {
            const res = await getData(url);
            const list = res?.results?.results || [];
            setLibraryListData(res?.results?.results)
            setfilterStudent(res?.results?.results);
            setTotalCount(res?.results?.count || 0);
            setNocStats({
                total_count: res?.total_count,
                pending_status_count: res?.pending_status_count,
                completed_status_count: res?.completed_status_count
            })

            // Auto-select first student

            // ✅ 🔥 RE-SYNC selected student after refresh
            if (selectedStudent?.student_id) {
                const updatedStudent = list.find(
                    (s) => s.student_id === selectedStudent.student_id
                );

                if (updatedStudent) {
                    setselectedStudent(updatedStudent);
                }
            }

            // First load auto-select
            if (isInitialLoad && list.length > 0 && !selectedStudent) {
                setselectedStudent(list[0]);
            }
            // ✅ Mark first load done here
            if (isFirstLoadRef.current) isFirstLoadRef.current = false;
            return res;
        } catch (err) {
            Notifier.error(err);
            setLibraryListData([]);
            setfilterStudent([])
            setTotalCount(0);
            return null;
        } finally {
            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
                setFilterLoading(false);
            }

            skipSpinnerRef.current = false;

        }
    };

    const currentPageRef = useRef(currentPage);
    const [activityStats, setActivityStats] = useState({
        activity_id: null,
        activity_name: "",
        total_students: 0,
        completed_students: 0,
        authentication_methods: [],
        pre_check_methods: [],
    });

    // const getActivityStatsCount = async () => {
    //     try {
    //         const res = await getData(`academics/activities/stats/?activity_id=${10}`);

    //         if (!res.error) {

    //             setActivityStats({
    //                 activity_id: res.activity_id,
    //                 activity_name: res.activity_name,
    //                 total_students: res.total_students,
    //                 completed_students: res.completed_students,
    //                 authentication_methods: res.authentication_methods || [],
    //                 pre_check_methods: res.pre_check_methods || [],
    //             });
    //         }
    //     } catch (error) {
    //         console.error("Error fetching activity stats", error);
    //     }
    // };

    // useEffect(() => {
    //     getActivityStatsCount()
    // }, [])

    useEffect(() => {
        if (isSearching && refreshKey === 0) return;

        // 2️⃣ Prevent stale API call ONLY in this rare case:
        //    User is still in search mode but search is technically empty
        // if (isSearchMode && !searchValueRef.current.trim()) return;

        // 3️⃣ Allowed → fetch data
        getActivityDatas(
            currentPage,
            filterQueryString,
        ).finally(() => stopTableLoading());

    }, [currentPage, filterQueryString, refreshKey]);

    // const modalOpenRef = useRef(false);

    // useEffect(() => {
    //     modalOpenRef.current = openStudentLedgerReportModal;
    // }, [openStudentLedgerReportModal]);


    const searchValueRef = useRef("");
    useEffect(() => {
        searchValueRef.current = searchValue;
    }, [searchValue]);

    // const modalOpenQueryRef = useRef({
    //     page: 0,
    //     query: '',
    //     sortField: sortField,
    //     sortOrder: sortOrder,
    // });

    // const openModalStudentIdRef = useRef(null);
    // const handleCloseModal = () => {
    //     setStudentLedgerReportModal(false)
    //     openModalStudentIdRef.current = null;
    // };


    const handleSetSearchResults = (data) => {
        let results = [];

        if (Array.isArray(data)) {
            results = data;
        } else if (data?.results) {
            results = data.results;
        } else if (data?.students?.results) {
            results = data.students.results;
        }

        // update filter state
        setfilterStudent(results);

        // --- NEW LOGIC: update selectedStudent ---s
        if (results.length > 0) {
            // Check if current selectedStudent still exists in new results
            const stillExists = results.find(
                (x) => x.student_id === selectedStudent?.student_id
            );

            if (stillExists) {
                setselectedStudent(stillExists); // update details with fresh data
            } else {
                setselectedStudent(results[0]); // fallback to first result
            }
        } else {
            setselectedStudent(null); // no results
        }
    };



    // const sortFieldRef = useRef(null);
    // const sortOrderRef = useRef(null);
    // useEffect(() => {
    //     sortFieldRef.current = sortField;
    //     sortOrderRef.current = sortOrder;
    // }, [sortField, sortOrder]);


    const handleSort = (field, order) => {
        let sortByValue = order; // default for all columns

        // Custom sort for NOC Status
        if (field === "noc_status") {
            sortByValue = order === "asc" ? "-status" : "status"; // Pending first = "-status", Completed first = "status"
        }

        setSortField(field);
        setSortOrder(sortByValue);

        // Keep refs in sync
        // sortFieldRef.current = field;
        // sortOrderRef.current = sortByValue;

        setCurrentPage(0);
        setIsFilterApplied(false);
        setfilterStudent([]);

        // const queryParams = new URLSearchParams(filterQueryString || "");
        // queryParams.set("order_by", sortByValue); // ✅ this will be -status or status


        setFilterQueryString(prev => ({
            ...prev,
            order_by: sortByValue,
        }));

        // getActivityDatas(0, field, sortByValue, newQuery, true);
    };

    const [studentInfo, setStudentInfo] = useState({
        userId: null,
        mobile: null,
    });
    const statusOptions = [
        { label: "Pending", value: "pending" },
        { label: "Completed", value: "completed" },
    ];
    const [selectedStatus, setSelectedStatus] = useState(null);


    const handleRowClick = async (activityId, row) => {
        try {
            setselectedStudent(row?.original)
        } catch (error) {
        }
    };
    const sourceData = useMemo(() => {

        return filterQueryString
            ? filterStudent || []
            : libraryListData || [];
    }, [libraryListData, filterStudent, filterQueryString]);

    const formattedData = useMemo(() => {
        return sourceData.map((event) => ({
            id: event?.id,  // unique
            student_id: event?.student_id,
            student_name: event.student_name,
            registration_number: event.registration_number,
            mobile: event.mobile,
            authentication_type: event?.authentication_type,
            authenticated_by: event?.authenticated_by,
            authenticated_at: event.authenticated_at,
            noc_status: event?.status,
            student_course: event?.student_course,

            handleRowClick,
        }));
    }, [sourceData]);


    const handlePageChange = ({ selected }) => {
        triggerTableLoading();
        setCurrentPage(selected);
    };



    const columns = useMemo(
        () => [

            {
                Header: "Student",
                accessor: 'student_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.student_name}
                        </p>
                        <span onClick={() => copyToClipboard(row.original.registration_number, "Reg No copied")}
                            style={{ textDecoration: 'underline' }} title='Copy Reg.No'>{row.original.registration_number}</span>


                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Course /Sem</p>,
                accessor: 'student_course',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {row.original?.student_course}
                            </p>

                        </div>
                    );
                }
            },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Authentication</p>,
                accessor: 'completed_authentications',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const auth = row.original?.authentication_type;
                    const status = row.original?.noc_status;

                    const isCompleted = status === "COMPLETED";

                    return (
                        <div style={{ textAlign: "left", display: "flex", alignItems: "center", gap: "6px" }} className="no-text-cursor">

                            {/* Authentication Name */}
                            <span
                                style={{
                                    fontWeight: 600,
                                    color: isCompleted ? "green" : "red"
                                }}
                            >
                                {auth}
                            </span>

                            {/* Check / Cross */}
                            <span
                                style={{
                                    color: isCompleted ? "green" : "red",
                                    fontWeight: 700,
                                    fontSize: "14px"
                                }}
                            >
                                {isCompleted ? "✔" : "✘"}
                            </span>
                        </div>
                    );
                }
            },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Status</p>,
                accessor: 'noc_status',
                disableSortBy: false,

                Cell: ({ row }) => {
                    const status = row.original?.noc_status; // "PENDING" or "COMPLETED"

                    // Capitalize first letter, lowercase rest
                    const formattedStatus = status
                        ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
                        : "";

                    return (
                        <div className="no-text-cursor">
                            <p
                                style={{
                                    textAlign: 'left',
                                    margin: 0,
                                    color: status === "PENDING" ? "red" : "green",
                                    fontWeight: 600,
                                    fontSize: "12px"
                                }}
                            >
                                {formattedStatus}
                            </p>
                        </div>
                    );
                }
            },


            {
                Header: () => <p style={{ textAlign: 'left' }}>Issued By</p>,
                accessor: 'authenticated_by',
                disableSortBy: true,

                Cell: ({ row }) => {
                    const issuedBy = row.original?.authenticated_by;

                    const displayValue =
                        issuedBy === null || issuedBy === undefined || issuedBy === ""
                            ? "Not Yet Issued"
                            : issuedBy;

                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {displayValue}

                            </p>
                            <span style={{ fontSize: '15px' }}>
                                {formatDateDDMMYYYYHHMMSS_UTC(row?.original?.authenticated_at)}
                            </span>
                        </div>
                    );
                }

            }


        ],
        []
    );



    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);

    // Sync selectedStudent after full API reload (clear search)
    useEffect(() => {
        if (!libraryListData) return;

        const fullList = libraryListData;

        const match = fullList.find(
            (s) => s.student_id === selectedStudent?.student_id
        );

        if (match) {
            setselectedStudent(match);
        } else {
            setselectedStudent(fullList[0]);
        }
    }, [libraryListData]);

    useEffect(() => {
        if (!formattedData || formattedData.length === 0) return;

        const match = formattedData.find(
            (s) => s.student_id === selectedStudent?.student_id
        );

        if (match) {
            setselectedStudent(match);
        } else {
            setselectedStudent(formattedData[0]);
        }
    }, [formattedData]);

    const handleSearchValueChange = (value) => {
        setSearchValue(value);

        if (!value.trim()) {
            setFilterQueryString((prev) => {
                if (!prev || typeof prev !== 'object') return {};
                const { search, ...rest } = prev;
                return rest;
            });
            setIsSearchMode(false);
            setIsSearching(false);
            setCurrentPage(0);
        } else {
            // Add search key to existing filter
            setFilterQueryString((prev) => ({
                ...(prev || {}),
                search: value.trim(),
            }));
            setIsSearchMode(true);
            setIsSearching(true);
            setCurrentPage(0);
        }
    };

    return (
        <>
            {isLoading ? (
                <TableSkeleton rows={10} columns={6} showHeader={true} />
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>

                    {/* ── FIXED: Title + Stats Card ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <div className="row d-flex justify-content-between align-items-center">

                            {/* LEFT: Title */}
                            <div className="col-md-5 d-flex align-items-center gap-2 mb-2">
                                <h2 className="main-heading m-0">Library NOC ({totalCount})</h2>
                            </div>

                            {/* RIGHT: Stats Card */}
                            <div className="col-md-7">
                                <div className="row g-3 d-flex justify-content-end">
                                    <div className="col-md-6">
                                        <div className="p-3 rounded shadow-sm h-100"
                                            style={{ background: "#fff", borderLeft: "4px solid #7F56DA" }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h6 className="m-0" style={{ fontWeight: 600 }}>Library NOC</h6>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span><strong>Total:</strong> {nocStats.total_count}</span>
                                                <span style={{ color: "green" }}><strong>Completed:</strong> {nocStats.completed_status_count}</span>
                                                <span style={{ color: "red" }}><strong>Pending:</strong> {nocStats.pending_status_count}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── FIXED: Search bar + Filters ── */}
                    <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                        <div className="col-md-8">
                            <div className="col-md-12 d-flex justify-content-end gap-2">
                                <SearchingBar
                                    placeholder="Search by name, registration no."
                                    url="academics/activities/library-noc-list/"
                                    filterQueryString={filterQueryString}
                                    setResults={handleSetSearchResults}
                                    ref={searchInputRef}
                                    setTotalCount={setTotalCount}
                                    setFilterQueryString={setFilterQueryString}
                                    setSearchLoading={setSearchLoading}
                                    setCurrentPage={setCurrentPage}
                                    setIsSearching={setIsSearching}
                                    isSearching={isSearching}
                                    setIsSearchMode={setIsSearchMode}
                                    setSearchValue={handleSearchValueChange}
                                    searchValue={searchValue}
                                />
                                <div style={{ width: "200px" }}>
                                    <Select
                                        options={statusOptions}
                                        value={selectedStatus}
                                        onChange={(option) => {
                                            setSelectedStatus(option);
                                            setFilterLoading(true);
                                            const updatedQuery = { ...filterQueryString };
                                            if (option) { updatedQuery.status = option.value; }
                                            else { delete updatedQuery.status; }
                                            setFilterQueryString(updatedQuery);
                                        }}
                                        isClearable
                                        placeholder="Status"
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={reactSelectStyles}
                                    />
                                </div>
                                <button
                                    style={{ border: "1px solid #7F56DA", background: 'none', height: '43px' }}
                                    onClick={() => setOpenDataUpload(true)}
                                >
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195" stroke="#7F56DA" strokeWidth="1.5" strokeLinecap="round" />
                                        <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="#7F56DA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ── SCROLLABLE BOTTOM: Table (left) + Details (right) ── */}
                    <div style={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden", padding: "0 12px" }}>

                        {/* LEFT: Table */}
                        <div style={{
                            flex: "0 0 66.67%",
                            maxWidth: "66.67%",
                            display: "flex",
                            flexDirection: "column",
                            minHeight: 0,
                            overflow: "hidden",
                            paddingRight: "12px"
                        }}>
                            {filterLoading ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                    <TableSkeleton />
                                </div>
                            ) : formattedData?.length > 0 ? (
                                <AdvanceTable
                                    columns={columns}
                                    pageCounts={pageCounts}
                                    handlePageChange={handlePageChange}
                                    selectedData={selectedStudent}
                                    data={formattedData}
                                    handleRowClick={handleRowClick}
                                    currentPage={currentPage}
                                    checkbox={false}
                                    handleSort={handleSort}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                />
                            ) : (!isLoading && !isSearchLoading && (
                                <div style={{
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", justifyContent: "center",
                                    flex: 1, color: "#888",
                                    borderRadius: "8px", textAlign: "center",
                                }}>
                                    No Library's NOC Data Found.
                                </div>
                            ))}
                        </div>

                        {/* RIGHT: Details Panel */}
                        <div className="shortdetails" style={{
                            flex: "0 0 33.33%",
                            maxWidth: "33.33%",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}>
                            <SingleLibraryDueDetails
                                selectedDetails={selectedStudent}
                                setselectedStudent={setselectedStudent}
                                getActivityDatas={getActivityDatas}
                                currentPage={currentPage}
                                studentInfo={studentInfo}
                                isSearchMode={isSearchMode}
                                filterQueryString={filterQueryString}
                                searchValue={searchValue}
                                setRefreshKey={setRefreshKey}
                            />
                        </div>
                    </div>

                    <TableLoaderOverlay isLoading={tableLoading} />
                </div>
            )}

            <UploadLibraryNocsData
                isOpen={openDataUpload}
                onClose={() => setOpenDataUpload(false)}
                getContestDatas={getActivityDatas}
                currentPage={currentPage}
                setRefreshKey={setRefreshKey}
            />
        </>
    );
}
